import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MessagingSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MessagingSettingsPage" */ "@circle-react/components/SettingsApp/Messaging"
    ),
);

export const MessagingSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MessagingSettingsComponent />
  </Suspense>
);
